<template>
  <div
    class="card"
    style="border: none; min-height: 100vh"
    id="print-lab-report"
  >
    <div class="card-body d-flex flex-column">
      <div>
        <div class="d-flex justify-content-end">
          <img src="/images/hayandra.jpeg" width="200" />
        </div>

        <div class="text-center">
          <h4
            style="font-weight: bold; ext-transform: uppercase; font-size: 16px"
          >
            <b>INVOICE</b>
            <!-- <hr
            style="
              border-bottom: 2px solid black;
              margin-right: 200px;
              margin-left: 200px;
              margin-top: 1px;
              margin-bottom: 5px;
            "
          /> -->
          </h4>
        </div>
        <div class="d-flex justify-content-end">
          <span style="font-weight: light" class="mr-25"
            >Jakarta, {{ data.date }}</span
          >
        </div>
        <div class="d-flex-justify-content-start">
          <div class="col pt-0">
            <div style="font-weight: bold">
              Invoice No <span class="ml-2 mr-1">:</span>
              <span style="font-size: 15px">{{ data.po_no }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex-justify-content-start">
          <div class="col pt-0" style="">
            <span style="">Kepada Yth,</span> <br />
            <span style="">
              {{ data.vendor_name }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-start mt-5">
          <div class="col pt-0">
            <div style="" v-html="data.opening_sentence"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-11" style="margin-left: 20px">
            <!-- <table class="table table-bordered my-table" style="font-size: 12px">
            <tr>
              <th class="p-2">No</th>
              <th class="p-2">Items</th>
              <th class="p-2">Quantity</th>
              <th class="p-2">Price/case(IDR)</th>
              <th class="p-2">Total Price</th>
            </tr>
            <tr v-for="(item, index) in data.items_display" :key="index">
              <td class="p-2">{{ index + 1 }}</td>
              <td class="p-2">{{ item.item }}</td>
              <td class="p-2">{{ item.quantity }}</td>
              <td class="p-2 text-right">{{ item.price }}</td>
              <td class="p-2 text-right">{{ item.total_price }}</td>
            </tr>
            <tr>
              <td class="p-2"></td>
              <td class="text-center p-2">
                <span style="font-weight: bold"> SUB TOTAL 1 </span>
              </td>
              <td class="p-2"></td>
              <td class="p-2"></td>
              <td class="p-2 text-right">
                {{ parseInt(subTotal).toLocaleString("id-ID") }}
              </td>
            </tr>
            <tr>
              <td class="p-2"></td>
              <td class="text-center p-2">
                <span style="font-weight: bold">
                  Diskon {{ data.discount }}%
                </span>
              </td>
              <td class="p-2"></td>
              <td class="p-2"></td>
              <td class="p-2 text-right" v-if="data.discount != 0">
                {{
                  parseInt((subTotal * data.discount) / 100).toLocaleString(
                    "id-ID"
                  )
                }}
              </td>
              <td class="p-2 text-right" v-if="data.discount == 0">
                {{ parseInt(subTotal).toLocaleString("id-ID") }}
              </td>
            </tr>
            <tr>
              <td class="p-2"></td>
              <td class="text-center p-2">
                <span style="font-weight: bold"> SUB TOTAL 2 </span>
              </td>
              <td class="p-2"></td>
              <td class="p-2"></td>
              <td class="p-2 text-right">
                {{ parseInt(subTotal2).toLocaleString("id-ID") }}
              </td>
            </tr>
            <tr>
              <td class="p-2"></td>
              <td class="text-center p-2">
                <span style="font-weight: bold" class="p-2">
                  PPn {{ data.ppn }}%
                </span>
              </td>
              <td class="p-2"></td>
              <td class="p-2"></td>
              <td class="p-2 text-right" v-if="data.ppn != 0">
                {{
                  parseInt((subTotal2 * data.ppn) / 100).toLocaleString("id-ID")
                }}
              </td>
              <td class="p-2 text-right" v-if="data.ppn == 0">
                {{ parseInt(subTotal2).toLocaleString("id-ID") }}
              </td>
            </tr>
            <tr>
              <td class="p-2"></td>
              <td class="text-center p-2">
                <span style="font-weight: bold"> TOTAL </span>
              </td>
              <td class="p-2"></td>
              <td class="p-2"></td>
              <td class="p-2 text-right">
                {{
                  parseInt(
                    (subTotal2 * data.ppn) / 100 + subTotal2
                  ).toLocaleString("id-ID")
                }}
              </td>
            </tr>
          </table> -->

            <table class="table table-bordered mt-4" style="">
              <thead style="margin-top: 20px">
                <tr>
                  <th>No</th>
                  <th>Item</th>
                  <th>Merk</th>
                  <th>Harga per unit</th>
                  <th>Jumlah</th>
                  <th>Satuan</th>
                  <th>Diskon</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(mdc, index) in data.items_display"
                  :key="mdc.id"
                  class="section-to-keep-together"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ mdc.name }}</td>
                  <td>{{ mdc.brand }}</td>
                  <td>{{ mdc.price }}</td>
                  <td>{{ mdc.quantity }}</td>
                  <td>{{ mdc.uom }}</td>
                  <td>
                    {{
                      mdc.is_percent == 1
                        ? `${mdc.discount_amount}% `
                        : `${formatRupiah(mdc.discount_amount)}`
                    }}
                  </td>
                  <td>{{ mdc.total_price }}</td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">Subtotal</td>
                  <td>{{ subtotal(data.items_display) }}</td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">
                    Diskon {{ data.discount }}%
                  </td>
                  <td>{{ discount(data.items_display) }}</td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">Total</td>
                  <td>{{ total(data.items_display) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="d-flex justify-content-start mt-2 section-to-keep-together">
          <div class="col">
            <!-- <span style="font-size: 12px">
            Demikian pesanan ini kami sampaikan, Mohon kiranya dapat di proses
            dengan segera.Atas perhatian dan kerjasamanya kami ucapkan terima
            kasih </span> -->
            <div style="" v-html="data.closing_sentence"></div>
            <br />
            <div class="d-flex justify-content-start">
              <div>
                <div>Pembayaran melalui Transfer ke :</div>
                <div>Yayasan Hayandra Peduli</div>
                <div>BCA 6340 225 226</div>
                <div>Mandiri 122 00 12 225 226</div>
              </div>
            </div>
            <br />
            <div
              class="d-flex flex-column align-items-start mt-3 section-to-keep-together"
            >
              <div style="">
                <b>Kepala Depo Farmasi</b> <br />
                <b>Klinik Utama Hayandra</b>
              </div>
              <div>
                <div class="signature mt-2" style="height: 150px; width: 150px">
                  <img
                    :src="data.pic_signature"
                    class="ml-2"
                    style="height: 100%; width: 100%; object-fit: contain"
                  />
                </div>
              </div>
              <div style="text-align: center">
                <span style="text-align: center">{{ data.pic_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 50px"></div>
      <div
        class="d-flex flex-column align-items-center section-to-keep-together"
        style="opacity: 0.5; margin-top: 10px"
      >
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Address</span
          >
          Jl. Kramat VI No. 11, Jakarta Pusat 10430, Indonesia
        </div>
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Phone</span
          >
          +62 811 935 4000
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >E-mail</span
          >
          info@hayandra.com
        </div>
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Website</span
          >
          www.hayandra.com
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    setting: Object,
  },

  data() {
    return {
      subTotal2: 5400000,
    };
  },

  methods: {
    formatRupiah(value) {
      if (!value) return "Rp 0";
      return Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(Number(value));
    },
    subtotal(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      return subtotal.toLocaleString("id-ID");
    },
    discount(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let discount = (subtotal * this.data.discount) / 100;
      return discount.toLocaleString("id-ID");
    },
    total(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let total = subtotal - (subtotal * this.data.discount) / 100;
      return total.toLocaleString("id-ID");
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf();
    },

    btnPrintOnClick() {
      this.$htmlToPaper("print-lab-report");
    },

    onProgress($event) {
      console.log("onProgress", $event);
    },

    hasStartedGeneration() {
      console.log("hasStartedGeneration");
    },

    hasGenerated($event) {
      console.log("hasGenerated", $event);
    },
  },
  computed: {
    // totalHarga() {
    //   return this.keranjangs.reduce(function (items, data) {
    //     return items + data.products.harga * data.jumlah_pemesanan;
    //   }, 0);
    // },
    // subTotal() {
    //   return this.data.items_display.reduce(function (items, data) {
    //     // console.log("items", items)
    //     // console.log("data", data.total_price)
    //     let total_price = data.total_price.replace(".", "");
    //     let count = items + parseInt(total_price);
    //     let count_replace = parseInt(count).toLocaleString("id-ID");
    //     return items + parseInt(total_price);
    //   }, 0);
    // },
  },
};
</script>

<style>
/* table.table-bordered {
  border: 1px solid black !important;
  margin-top: 20px;
}
table.table-bordered > thead > tr > th {
  border: 1px solid black !important;
}
table.table-bordered > tbody > tr > td {
  border: 1px solid black !important;
} */
/* .my-table>tbody>tr>td, .mytable>tbody>tr>th, .mytable>tfoot>tr>td, .mytable>tfoot>tr>th, .mytable>thead>tr>td, .mytable>thead>tr>th {
    padding: 12px;
} */
.signature {
  height: 150px;
  width: 150px;
}

.signature img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.text-hayandra-primary {
  color: #993366;
}
</style>

<style>
@media print {
  @page {
    margin-top: 20mm;
    margin-bottom: 20mm;
  }

  /* Tambahkan jarak atas di setiap halaman baru */
  #print-lab-report {
    page-break-inside: avoid;
  }

  .card-body {
    padding-top: 15mm; /* biar isi halaman kedua tidak terlalu mepet ke atas */
  }
}
</style>